import React from "react";
import {cx} from "../../lib/ClassSet";
import {List} from "immutable";
import "./OrderItem.css";
import {formatFulfillmentStatus} from "../../lib/FulfillmentStatus";
import {ComplimentaryTag, ReplacementTag, GiftTag, SalesTag, ExternalOrderTag} from "../../components/MiniTag";

const completedStates = List(["delivered", "partially_delivered", "replaced", "partially_replaced"])

const OrderItem = (props) => {

  let {data} = props;
  
  const isSales = data.get("salesOrderId", "").length === 32;
  const isComplimentary = data.get("type") === "complimentary";
  const isReplacement = data.get("type") === "replacement";
  const isGift = data.get("gift") === true;
  const isExternalOrder = data.get("externalSource") !== "";

  let classes = cx({
    "item": true,
    "shipping-order-list-item": true,
    "u-warning": data.get("pickupOverdue") || data.get("hold"),
    "u-selected": props.selected,
    "u-cancelled": data.get("fulfillmentStatus") === "cancelled",
    "u-completed": completedStates.includes(data.get("fulfillmentStatus")),
    "u-sales": isSales,
    "u-complimentary": isComplimentary,
    "u-replacement": isReplacement,
    "u-gift": isGift,
    "u-external-order": isExternalOrder,
  })

  let status = data.get("fulfillmentStatus");
  if (data.get("scheduled") && status === "ready") {
    status = "scheduled";
  }
  if (data.get("hold") === true) {
    status = "hold";
  }

  return (
    <tr className={classes} onClick={(e) => props.onClick(data, e)}>
      <td className="field f-id" onClick={(e) => props.onClick(data, e, "id")}>{data.get("orderId")}</td>
      <td className="field">{data.get("nrPackages")}</td>
      <td className="field">{data.getIn(["deliveryAddress", "name"])}</td>
      <td className="field">{data.getIn(["deliveryAddress", "addressCountryCode"])}</td>
      <td className="field f-warehouse">{data.get("warehouseId")}</td>
      <td className="field f-date">{data.get("prepDate")}</td>
      <td className="field f-date">{data.get("pickupDate")}</td>
      <td className="field f-x">
        <SalesTag show={isSales} />
        <ComplimentaryTag show={isComplimentary} />
        <ReplacementTag show={isReplacement} />
        <GiftTag show={isGift} />
        <ExternalOrderTag show={isExternalOrder} source={data.get("externalSource")} />
      </td>
      <td className="field f-fulfillment"><span className="icon" /><span className="text">{formatFulfillmentStatus(status)}</span></td>
    </tr>
  )
}

export default OrderItem;